// extracted by mini-css-extract-plugin
export default {"notificationPopupOnRight":"NotificationPopupOnRight_notificationPopupOnRight__kGD4U","notificationPopupOnRight_open":"NotificationPopupOnRight_notificationPopupOnRight_open__89yDg"};